// extracted by mini-css-extract-plugin
export var dropdownIcon = "_pz-6";
export var imgContainer = "_pz-3";
export var menuIcon = "_pz-5";
export var pillWrapper = "_pz-2";
export var pillsContainer = "_pz-1";
export var subscriptionCard = "_pz-0";
export var subscriptionLogo = "_pz-4";